import BookIcon from "@svg/new-design/book";
import Graduated from "@svg/new-design/graduated";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { FC } from "react";
import LandingCardFooter from "./landing-footer";
import CardTitle from "@shared/components/card/card-title";

interface Props {
  courseCount?: number;
  studentCount?: number;
  href: string;
  title: string;
  hugElement: boolean;
}
const LandingBody: FC<Props> = ({
  courseCount,
  studentCount,
  href,
  title,
  hugElement,
}) => {
  return (
    <div className="flex-col flex justify-between gap-1 sm:gap-1.5 mr-2">
      <CardTitle hugElement={hugElement} title={title} />
      <div className="h-12 flex-col gap-y-1 sm:gap-y-1.5  flex">
        {studentCount !== 0 && (
          <div className="flex items-center gap-1 sm:gap-1.5  text-fds-secondary">
            <Graduated className="text-fds-icon-secondary sm:h-5 sm:w-5 h-4 w-4" />
            <p className="text-fds-secondary body-xxsm sm:body-xsm">
              {`${separateMoneyNumbers(toFarsiNumber(studentCount))} دانشجو`}
            </p>
          </div>
        )}
        {courseCount !== 0 && (
          <div className="flex items-center gap-1 sm:gap-1.5  text-fds-secondary">
            <BookIcon className="text-fds-icon-secondary sm:h-5 sm:w-5 h-4 w-4" />
            <p className="text-fds-secondary body-xxsm sm:body-xsm">
              {`${separateMoneyNumbers(toFarsiNumber(courseCount))} آموزش`}
            </p>
          </div>
        )}
      </div>
      <LandingCardFooter link={href} />
    </div>
  );
};

export default LandingBody;
